import HttpService from "./HttpService";

export default {
    personaliceCard(idTarjeta,cedula,nombre,apellido,fechaNacimiento,correo,idPais,identificador,codigo,celular) {
        //const urlDES = "http://209.97.181.190:9091/bus/tarjeta/asociarTarjeta";
        const urlPRO = "https://recursos.kbus.kradac.com/bus/tarjeta/asociarTarjeta";
        return new Promise((resolve, reject) => {
            HttpService.post(urlPRO, {
                idTarjeta,
                cedula,
                nombre,
                apellido,
                fechaNacimiento,
                correo,
                idPais: idPais ? idPais: 1,
                identificador: identificador ? "0":"1",
                codigo,
                celular
            }).then((response) => {
                if (response.data.en === 1) {
                    resolve(response.data);
                    return;
                }
                reject(response.data);
            }).catch((error) => reject(error));
        })
    },
    generarOtp(idTarjeta, correo, celular) {
        //const urlDES = "http://209.97.181.190:9091/bus/tarjeta/generarOtp";
        const urlPRO = "https://recursos.kbus.kradac.com/bus/tarjeta/generarOtp";
        return new Promise((resolve, reject) => {
            HttpService.post(urlPRO, {
                idTarjeta,
                correo,
                celular
            }).then((response) => {
                if (response.data.en == 1) {
                    resolve(response.data);
                    return;
                }
                reject(response.data);
            }).catch((error) => reject(error));
        })
    },
    validarOtp(idTarjeta, otp) {
        //const urlDES = "http://209.97.181.190:9091/bus/tarjeta/validarOtp";
        const urlPRO = "https://recursos.kbus.kradac.com/bus/tarjeta/validarOtp";
        return new Promise((resolve, reject) => {
            HttpService.post(urlPRO, {
                idTarjeta,
                otp
            }).then((response) => {
                if (response.data.en == 1) {
                    resolve(response.data);
                    return;
                }
                reject(response.data);
            }).catch((error) => reject(error));
        })
    }
}
